/**
 * Invoice status enum matching backend
 */
export enum InvoiceStatus {
    Pending = 0,
    Paid = 1,
    Overdue = 2,
    Cancelled = 3
}

/**
 * Partner Invoice DTO
 */
export interface PartnerInvoiceDto {
    invoiceId?: string;
    partnerId?: string;
    partnerName?: string;
    invoiceDate?: string;
    billingPeriodStart?: string;
    billingPeriodEnd?: string;
    amountDue?: number;
    totalAmount?: number;
    status?: string;
    invoiceDownloadUrl?: string;
    transactionCount?: number;
    redemptionReferences?: string[];
    createdAt?: string;
    updatedAt?: string;
}

/**
 * Get status label for display
 */
export function getInvoiceStatusLabel(status?: string): string {
    if (!status) return 'Unknown';

    switch (status.toLowerCase()) {
        case 'pending':
            return 'Pending';
        case 'paid':
            return 'Paid';
        case 'overdue':
            return 'Overdue';
        case 'cancelled':
            return 'Cancelled';
        default:
            return status;
    }
}

/**
 * Get status CSS class
 */
export function getInvoiceStatusClass(status?: string): string {
    if (!status) return 'unknown';

    switch (status.toLowerCase()) {
        case 'pending':
            return 'pending';
        case 'paid':
            return 'paid';
        case 'overdue':
            return 'overdue';
        case 'cancelled':
            return 'cancelled';
        default:
            return 'unknown';
    }
}
